import { sendClickHouseAnalytic } from '@shared/api/analytics/template'

// Уникальные события для листинга
export const EGGListing = {
  // 1. Отобразился экран
  appear_screen_page: () =>
    sendClickHouseAnalytic({
      event_name: 'screen_appear',
    }),
}
